// client/src/v2/domains/home/home.service.js

/**
 * Home Location Service
 * ---------------------
 * Orchestrates postcode → lat/lon resolution.
 *
 * IMPORTANT:
 * - No UI concerns beyond preserving thrown Error.message for TopBar
 */

import { fetchLatLonByPostcode } from "./home.api";
import { UI_MSG } from "../../config/uiMessages";

/**
 * Resolve a postcode into a home location.
 *
 * @param {string} postcode
 * @returns {Promise<{ lat: number, lon: number }>}
 */
export async function resolveHomeLocation(postcode) {
  if (!postcode || typeof postcode !== "string") {
    throw new Error(UI_MSG.POSTCODE_INVALID);
  }

  const trimmed = postcode.trim();
  if (!trimmed) {
    throw new Error(UI_MSG.POSTCODE_INVALID);
  }

  try {
    return await fetchLatLonByPostcode(trimmed);
  } catch (err) {
    // Keep coded errors (404 / 400 / upstream) so TopBar shows the right copy
    if (err && (err.code === 404 || err.code === 400 || err.code >= 500)) {
      throw err;
    }
    if (err?.message) throw err;
    throw new Error(UI_MSG.POSTCODE_LOOKUP_UNAVAILABLE);
  }
}
